import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel'
import {
  createTheme,
  makeStyles,
  MuiThemeProvider
} from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
// core components
import styles from 'assets/jss/style-component/components/customInputStyle.js'
import classNames from 'classnames'
import { GridItem } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import ReactTooltip from 'react-tooltip'
import { TIPO_INPUT } from 'util/common/const.js'
import _ from 'lodash'

const useStyles = makeStyles(styles)

const theme = createTheme({
  overrides: {
    MuiInputLabel: {
      root: {
        color: '#3c4858',
        fontSize: 'small  !important'
      }
    },
    MuiInputBase: {
      root: {
        marginBottom: '10px !important',
        /*ckgroundColor: "#ffffff94",*/
        fontSize: 'small  !important'
      },
      input: {
        /*ckgroundColor: "#ffffff94",*/
        fontSize: 'small  !important'
      }
    },

    MuiOutlinedInput: {
      root: {
        borderRadius: '4px',
        minHeight: '35px!important',
        '& $notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.23)'
        },
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: '#4A90E2',
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            borderColor: 'rgba(0, 0, 0, 0.23)'
          }
        },
        '&$focused $notchedOutline': {
          borderColor: '#4A90E2',
          borderWidth: 1
        }
      }
    }
  }
})

function CustomInputFormik(props) {
  const classes = useStyles()
  const {
    formik,
    name,
    labelText,
    id,
    labelProps,
    maxLength,
    success,
    disabled,
    helperText,
    sm,
    md,
    type,
    multiline,
    rowsInput,
    autoFocus,
    variant,
    icon,
    required,
    className,
    placeholder
  } = props

  const { values, touched, errors, handleChange, handleBlur } = formik
  let fieldName = name
  const { value: fieldValue } = formik.getFieldMeta(fieldName)
  let fieldProps = formik.getFieldProps(fieldName)
  //const error = touched[name] && errors[name]
  const error = _.get(touched, name) && _.get(errors, name)

  let typeField = type === undefined ? 'text' : type
  let variantField = 'standard'
  const labelClasses = classNames({
    [' ' + classes.labelRootError]: error,
    [' ' + classes.labelRootSuccess]: success && !error
  })

  return (
    <GridItem xs={12} sm={sm === null ? 12 : sm} md={md}>
      <MuiThemeProvider theme={theme}>
        {labelText !== undefined && (
          <InputLabel
            className={classes.labelRoot + labelClasses}
            htmlFor={id}
            {...labelProps}
          >
            {labelText}
          </InputLabel>
        )}

        <TextField
          {...fieldProps}
          formik={formik}
          data-tip={helperText}
          id={name}
          name={name}
          error={!!error}
          //value={value}
          placeholder={placeholder}
          fullWidth
          onChange={handleChange}
          helperText={error}
          onBlur={handleBlur}
          disabled={disabled}
          size="small"
          variant={variantField}
          InputLabelProps={{
            shrink: true
          }}
          type={typeField}
          multiline={multiline}
          minRows={rowsInput ? rowsInput : 1}
          autoFocus={autoFocus}
          InputProps={
            icon && {
              startAdornment: (
                <InputAdornment position="start">
                  <i className="material-icons">{icon}</i>
                </InputAdornment>
              )
            }
          }
          inputProps={{
            autoComplete: 'off',
            maxLength: maxLength
          }}
          required={required ? required : false}
          className={className}
        />
        <ReactTooltip />
      </MuiThemeProvider>
    </GridItem>
  )
}
CustomInputFormik.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  maxLength: PropTypes.number,
  formControlProps: PropTypes.object,
  value: PropTypes.string,
  defaultValue: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  onInput: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  helperText: PropTypes.string,
  sm: PropTypes.number,
  md: PropTypes.number,
  inputEl: PropTypes.object,
  type: PropTypes.string,
  blanco: PropTypes.string,
  multiline: PropTypes.bool,
  rowsInput: PropTypes.number,
  autoFocus: PropTypes.bool,
  variant: PropTypes.string,
  icon: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string
}

export default CustomInputFormik
